import React, { useEffect } from 'react';
import { Routes, Route, useParams, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Actions
import { gameActions } from '../../actions';

// Components
import GameForm from './form';
import GameFormHBP from './form_hbp';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';
import { GameOffers } from './debrief_offers';
import { GameTypes } from './debrief_types';
import { GamePareto } from './debrief_pareto';
import { GameLeaderboard } from './leaderboard';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const user = useSelector((state) => state.authentication.user);
  const { id } = useParams();
  const { i18n } = useTranslation();
  // INTERNATIONALIZATION
  const { default_lang } = game?.data || {};
  const i18nextSetBy = localStorage.getItem('i18nextSetBy');

  // Effects
  useEffect(() => {
    dispatch(gameActions.fetchGames(id));
  }, [dispatch, id]);

  // INTERNATIONALIZATION
  useEffect(() => {
    if (default_lang?.length > 0 && i18nextSetBy !== user?.email) {
      console.log('Setting language to', default_lang);
      i18n.changeLanguage(default_lang);
    }
  }, [default_lang, i18n, user?.email]); // Only run when default_lang, i18n instance, or user email changes

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameFormHBP
      : GameForm;

  // Location validations
  const { pathname } = window.location;
  const isSaved = game?.data?.status === 'saved';

  // When saved: Useful when creating a new run (snapshot)
  const redirectWhenSaved = ['/players', '/debrief'];
  if (isSaved && redirectWhenSaved.some((s) => pathname.includes(s))) {
    return <Navigate to={'/games/' + game?.data?._id} />;
  }

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />
            <Route path='debrief/overview' element={<GameDebrief />} />

            {/* Sim-specific */}
            <Route path='debrief/offers' element={<GameOffers />} />
            <Route path='debrief/types' element={<GameTypes />} />
            <Route path='debrief/pareto' element={<GamePareto />} />

            <Route path='debrief/leaderboard' element={<GameLeaderboard />} />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
